/* Zenko · i18n translations (ES default, EN secondary) */
export const translations = {
  es: {
    nav: {
      origen: "Origen",
      servicios: "Servicios",
      proceso: "Cómo trabajamos",
      casos: "Casos",
      demo: "Demo en vivo",
      precios: "Precios",
      faq: "FAQ",
      cta: "Agenda llamada",
    },
    hero: {
      badge_new: "Nuevo",
      badge_text: "Automatización con IA · España · LATAM · US",
      title_l1: "Tu negocio,",
      title_highlight: "en piloto",
      title_l2: "automático",
      subtitle_a: "Páginas web profesionales, chatbots en WhatsApp y tiendas online que ",
      subtitle_b: "venden por ti",
      subtitle_c: " — mientras duermes, cocinas o atiendes a tu cliente número 47.",
      cta_primary: "Agenda una llamada gratis",
      cta_secondary: "Prueba el chatbot en vivo",
      scroll_cue: "desplázate para explorar",
      card_wa: "WhatsApp",
      card_wa_title: "Nueva venta",
      card_wa_time: "3:42 AM · ticket #1284",
      card_sales: "Ventas hoy",
      card_sales_delta: "+38% vs ayer",
      card_typing: "Zen está respondiendo",
      card_typing_msg: "Confirmo tu reserva para 4 personas el sábado a las 8 PM ✅",
    },
    trust: {
      label: "diseñado para pymes en",
      items: [
        "Restaurantes",
        "Cafeterías",
        "Estéticas & spas",
        "Talleres mecánicos",
        "Boutiques de moda",
        "eCommerce",
        "Clínicas dentales",
        "Estudios creativos",
        "Pymes de servicios",
      ],
    },
    stats: [
      { value: 100, suffix: "%", label: "Diseño a medida", desc: "nada de plantillas genéricas" },
      { value: 24, suffix: "/7", label: "Atención continua", desc: "tu chatbot no descansa nunca" },
      { value: 2, suffix: "s", prefix: "< ", label: "Respuesta del bot", desc: "más rápido que un humano" },
      { value: 14, suffix: " días", label: "De brief a online", desc: "tu web lista para vender" },
    ],
    origin: {
      eyebrow: "nuestra historia",
      title_q: "¿Por qué ",
      title_name: "Zenko",
      title_end: "?",
      char1_label: "Japonés · Coreano",
      char1_jp: "Zen",
      char1_kr: "Seon",
      char1_meaning: "Bondad · Claridad · Hacer el bien",
      char2_label: "Japonés",
      char2_jp: "Ko",
      char2_meaning: "Zorro · Mensajero inteligente",
      story_p1_a: "Zenko tiene raíces en la cultura ",
      story_p1_b: "japonesa y coreana",
      story_p1_c: ". En japonés, ",
      story_p1_d: " significa ",
      story_p1_e: "“zorro bueno”",
      story_p1_f: " — el mensajero inteligente que en la mitología shintoísta trabaja en silencio para traer prosperidad a los negocios. ",
      story_p1_g: "No engaña, no complica",
      story_p1_h: " — actúa con precisión y lealtad para que las cosas sucedan.",
      story_p2_a: "En coreano, el carácter ",
      story_p2_b: " se lee ",
      story_p2_c: "Seon",
      story_p2_d: " y significa ",
      story_p2_e: "bondad y claridad",
      story_p2_f: " — hacer las cosas bien, sin ruido innecesario.",
      story_right_a: "Juntos, los dos significados definen perfectamente lo que somos: ",
      story_right_b: "un aliado inteligente",
      story_right_c: " que trabaja en silencio detrás de tu negocio, con tecnología de IA, para que tú veas resultados sin tener que entender cómo funciona por dentro.",
      manifesto_eyebrow: "— el manifiesto",
      manifesto_a: "Zenko ",
      manifesto_b: "no es el protagonista",
      manifesto_c: " — hace que ",
      manifesto_d: "tú lo seas",
      manifesto_e: ".",
    },
    process: {
      eyebrow: "cómo trabajamos",
      title_a: "Del caos al ",
      title_h: "piloto automático",
      title_b: " en 14 días.",
      subtitle: "Sin reuniones eternas. Sin contratos que no entiendes. Solo 3 pasos.",
      steps: [
        { n: "01", time: "Día 1", title: "Diagnóstico", desc: "Llamada de 30 min. Mapeamos qué tareas te quitan tiempo y qué clientes se te escapan por no responder a tiempo.", deliverable: "Plan personalizado · gratis" },
        { n: "02", time: "Día 2–10", title: "Diseño + IA", desc: "Diseñamos tu web y entrenamos a tu chatbot con tu menú, precios, FAQ y tono de marca. Lo apruebas tú.", deliverable: "Prototipo + flujos del bot" },
        { n: "03", time: "Día 14", title: "Lanzamiento", desc: "Subimos todo a tu dominio, conectamos WhatsApp Business y te entrenamos a ti y tu equipo en 1 sesión.", deliverable: "Online · midiendo ventas" },
      ],
    },
    services: {
      eyebrow: "servicios",
      title_a: "Tres soluciones. Un objetivo:",
      title_h: "vendas más",
      title_b: " con menos esfuerzo.",
      subtitle: "Combínalas o úsalas por separado. Tú decides cómo escalar.",
      cta: "Quiero esto",
      items: [
        { title: "Páginas Web con IA", tagline: "Tu sitio que vende mientras duermes", bullets: ["Diseño a medida (no plantillas genéricas)", "Optimizada para Google · SEO incluido", "Velocidad de carga < 1.5 seg"] },
        { title: "Chatbot WhatsApp", tagline: "Responde, agenda y vende sin ti", bullets: ["Conectado a tu WhatsApp Business", "Entrenado con tu menú, precios y FAQ", "Agenda citas y cobra dentro del chat", "Te avisa cuando algo necesita tu atención"] },
        { title: "eCommerce Inteligente", tagline: "Tienda online con cobros automáticos", bullets: ["Catálogo ilimitado · gestiona desde el celu", "Pagos: tarjeta, transferencia, efectivo", "Recordatorios automáticos a carritos abandonados", "Integración con WhatsApp para soporte"] },
      ],
      preview_real: "Caso real · cliente",
      preview_live: "en vivo",
      preview_see: "ver en vivo →",
    },
    demo: {
      eyebrow: "demo en vivo",
      title_a: "Ve a tu próximo bot,",
      title_h: "trabajando.",
      subtitle: "Esto es lo que tus clientes reciben en WhatsApp. Cambia entre escenarios y observa cómo Zen maneja cada conversación sin perder el tono humano.",
      bullets: [
        { t: "Responde en < 2 segundos", d: "incluso a las 3 AM" },
        { t: "Convierte 3× más conversaciones", d: "que un humano cansado" },
        { t: "Aprende de tu negocio", d: "y mejora con cada chat" },
      ],
      phone_name: "Zen · Asistente IA",
      phone_status: "en línea · responde al instante",
      phone_placeholder: "Escribe un mensaje...",
      open_link: "Abrir enlace →",
      hint: "↑ Demo en vivo · Cambia entre escenarios",
      tabs: [
        { id: "reservas", label: "Reservas", emoji: "📅" },
        { id: "ventas", label: "Ventas", emoji: "💰" },
        { id: "soporte", label: "Soporte", emoji: "🎧" },
      ],
    },
    comparison: {
      eyebrow: "antes vs después",
      title_a: "El día que ",
      title_h: "dejas de perder clientes",
      title_b: " por no responder.",
      subtitle: "Estos son los cambios reales en nuestras pymes el primer mes con Zenko.",
      col_metric: "Métrica",
      col_before: "Sin Zenko",
      col_after: "Con Zenko",
      rows: [
        { topic: "Respuesta a clientes nuevos", before: "2 a 6 horas", after: "< 2 segundos" },
        { topic: "Atención fines de semana", before: "Inexistente", after: "Continua, 24/7" },
        { topic: "Carritos / reservas perdidas", before: "~40%", after: "< 8%" },
        { topic: "Tu tiempo respondiendo chats", before: "3 hrs / día", after: "20 min / día" },
        { topic: "Capacidad de atender clientes", before: "1 a la vez", after: "Cientos en paralelo" },
      ],
    },
    case_study: {
      eyebrow: "caso de éxito",
      title_a: "MotoTuning C.A.,",
      title_h: "digital desde cero",
      title_b: ".",
      subtitle: "Cómo le creamos a una ensambladora venezolana su primera presencia digital profesional en menos de 14 días.",
      label_brief: "El brief",
      brief: "Ensambladora y distribuidora de motocicletas en Aragua, Venezuela. Sin web, sin presencia digital. Necesitaban un sitio profesional para mostrar sus 3 modelos, recibir consultas mayoristas y posicionarse como marca seria frente a la competencia internacional.",
      label_solution: "Lo que entregamos",
      solution: [
        "Diseño y desarrollo de web institucional desde cero",
        "Dominio mototuningca.com configurado",
        "Hosting profesional incluido (1 año)",
        "Sección de modelos con specs detalladas",
        "Formulario de contacto mayorista",
        "Optimización móvil completa",
      ],
      label_outcome: "El resultado",
      outcome_a: "Presencia digital real ",
      outcome_b: "para el negocio. Web lista para escalar a catálogo eCommerce cuando ellos quieran.",
      label_time: "Tiempo total",
      time: "10 días · brief a producción",
      label_quote: "Las palabras del cliente",
      quote: "Zenko nos creó una página web profesional desde cero, con dominio y hosting incluidos. El proceso fue rápido, el resultado superó lo que esperábamos y ya tenemos presencia digital real para nuestro negocio. Totalmente recomendados.",
      quote_attr: "MotoTuning C.A. · Aragua, Venezuela",
      visit: "Ver el sitio en vivo",
      next_label: "¿Tu caso, el próximo?",
      next_cta: "Cuéntanos de tu negocio",
    },
    powered_by: {
      eyebrow: "tecnología que usamos",
      title_a: "Construido sobre las ",
      title_h: "mejores herramientas",
      title_b: " del mercado.",
      subtitle: "No reinventamos la rueda. Conectamos las APIs líderes para que tu negocio se beneficie de tecnología de clase mundial.",
      items: [
        { name: "WhatsApp Business", desc: "Mensajería oficial verificada" },
        { name: "OpenAI · Claude", desc: "Modelos de IA conversacional" },
        { name: "Google Workspace", desc: "Calendario · Meet · Drive" },
        { name: "Stripe", desc: "Pagos seguros · multimoneda" },
        { name: "Cal.com", desc: "Agendamiento automático" },
        { name: "Vercel · AWS", desc: "Hosting de alta velocidad" },
      ],
    },
    pricing: {
      offer: "Oferta de lanzamiento · primeros 30 días",
      eyebrow: "precios transparentes",
      title_a: "Inversión clara. ",
      title_h: "Sin sorpresas.",
      subtitle: "Tu desarrollo + mantenimiento mensual para que tu sitio y tu bot siempre estén funcionando.",
      from: "desde",
      one_time: "inversión inicial",
      maint: "+ mantenimiento mensual",
      iva_note: "* IVA no incluido. Aplica a los tres planes.",
      popular: "⭐ Más elegido",
      help_a: "¿No estás seguro qué plan necesitas? ",
      help_b: "Te ayudamos a decidir →",
      plans: [
        { name: "Web Informativa", price: "300", tag: "Ideal para empezar", featured: false, perks: ["1 página o landing", "Diseño a medida", "Formulario de contacto", "Hosting + dominio (1 año)", "Optimización SEO básica"] },
        { name: "Web + Chatbot WA", price: "700", tag: "Más popular · 70% lo elige", featured: true, perks: ["Todo lo anterior +", "Chatbot WhatsApp con IA", "Entrenamiento personalizado", "Agendamiento automático", "Reportes mensuales"] },
        { name: "eCommerce IA", price: "1.500", tag: "Para escalar en serio", featured: false, perks: ["Tienda online completa", "Catálogo ilimitado", "Pagos integrados", "Chatbot de ventas", "Recuperación de carritos"] },
      ],
      start: "Empezar con",
    },
    testimonials: {
      eyebrow: "lo que dicen nuestros clientes",
      title_a: "Historias reales,",
      title_h: "resultados reales",
      title_b: ".",
      real_label: "caso real",
      placeholder_title: "Tu historia, aquí.",
      placeholder_desc_a: "Estamos firmando nuevos casos cada semana.",
      placeholder_desc_b: "El próximo podría ser el tuyo.",
      cta_eyebrow: "¿Quieres ser el siguiente?",
      cta_title: "Agenda una llamada y cuéntanos de tu negocio.",
      cta_action: "Empezar ahora",
      visit_site: "Ver el sitio creado",
    },
    faq: {
      eyebrow: "dudas frecuentes",
      title: "Resolvemos lo que todos preguntan.",
      items: [
        { q: "¿Cuánto demora tener todo funcionando?", a: "Entre 7 y 14 días desde que aprobamos el brief. Webs simples van más rápido; eCommerce con chatbot toma los 14 completos." },
        { q: "¿Necesito saber de tecnología?", a: "Para nada. Tú nos cuentas tu negocio en una llamada y nosotros nos encargamos de todo. Te entregamos un panel sencillo donde editas textos y precios si quieres." },
        { q: "¿El chatbot suena robótico?", a: "No. Lo entrenamos con tu tono de marca, jergas locales y respuestas que tú apruebas. La mayoría de clientes ni se da cuenta de que es un bot." },
        { q: "¿Qué pasa si quiero cambiar algo después?", a: "Cambios menores (textos, precios, fotos) los haces tú desde el panel. Para cambios grandes, te damos soporte por WhatsApp directo conmigo." },
        { q: "¿Cobran mensualidad?", a: "Sí. El precio del plan cubre el desarrollo inicial. Luego se aplica una mensualidad de mantenimiento que incluye hosting, dominio, soporte por WhatsApp, actualizaciones de contenido y mejoras del chatbot. Te detallamos el monto exacto según el plan en la llamada." },
        { q: "¿En qué países atienden?", a: "Atendemos España, toda Latinoamérica y Estados Unidos. Los pagos los recibes en tu moneda local y soportamos múltiples idiomas (ES/EN) para tu chatbot." },
      ],
    },
    cta_section: {
      offer: "Cupos limitados · enero 2026",
      title_a: "¿",
      title_h: "Empezamos hoy",
      title_b: "?",
      subtitle: "Elige el día y la hora que mejor te venga. Llamada de 15 min, gratis y sin compromiso.",
      hint: "↑ Haz clic en un día disponible (marcado en menta) para ver los horarios",
      alt_label: "o si prefieres escribirnos directamente",
      wa: "WhatsApp directo",
      phone: "+34 697 718 231",
      checks: ["✓ Llamada gratis", "✓ Sin obligación", "✓ Respondemos en < 2 horas", "✓ Plan personalizado"],
    },
    floating: {
      text_a: "✦ ¿Listo para tu primera automatización?",
      cta: "Agenda llamada",
      close: "Cerrar",
    },
    footer: {
      tagline: "Automatización con IA para pymes que quieren crecer sin complicarse.",
      values: [
        { jp: "誠", label: "Lealtad", desc: "trabajamos por tu éxito" },
        { jp: "静", label: "Silencio", desc: "sin ruido innecesario" },
        { jp: "智", label: "Inteligencia", desc: "IA al servicio del negocio" },
        { jp: "栄", label: "Prosperidad", desc: "resultados que se sienten" },
      ],
      cols: [
        { t: "Servicios", l: ["Páginas web", "Chatbot WhatsApp", "eCommerce IA", "Soporte"] },
        { t: "Empresa", l: ["Nosotros", "Casos de éxito", "Blog", "Contacto"] },
        { t: "Legal", l: ["Términos", "Privacidad", "Cookies"] },
      ],
      copy: "© {year} Zenko · Hecho con IA y mucho cariño · España · LATAM · US",
      wa_hover: "¡Hablemos!",
      instagram: "Síguenos en Instagram",
    },
    common: {
      lang_es: "ES",
      lang_en: "EN",
    },
  },

  en: {
    nav: {
      origen: "Origin",
      servicios: "Services",
      proceso: "How we work",
      casos: "Cases",
      demo: "Live demo",
      precios: "Pricing",
      faq: "FAQ",
      cta: "Book a call",
    },
    hero: {
      badge_new: "New",
      badge_text: "AI Automation · Spain · LATAM · US",
      title_l1: "Your business,",
      title_highlight: "on autopilot",
      title_l2: "— for real",
      subtitle_a: "Professional websites, WhatsApp chatbots and online stores that ",
      subtitle_b: "sell for you",
      subtitle_c: " — while you sleep, cook or attend customer #47.",
      cta_primary: "Book a free call",
      cta_secondary: "Try the chatbot live",
      scroll_cue: "scroll to explore",
      card_wa: "WhatsApp",
      card_wa_title: "New sale",
      card_wa_time: "3:42 AM · ticket #1284",
      card_sales: "Sales today",
      card_sales_delta: "+38% vs yesterday",
      card_typing: "Zen is replying",
      card_typing_msg: "I confirm your reservation for 4 people Saturday at 8 PM ✅",
    },
    trust: {
      label: "built for SMBs in",
      items: [
        "Restaurants",
        "Coffee shops",
        "Beauty & spas",
        "Workshops",
        "Fashion boutiques",
        "eCommerce",
        "Dental clinics",
        "Creative studios",
        "Service SMBs",
      ],
    },
    stats: [
      { value: 100, suffix: "%", label: "Custom design", desc: "no generic templates" },
      { value: 24, suffix: "/7", label: "Always-on support", desc: "your bot never rests" },
      { value: 2, suffix: "s", prefix: "< ", label: "Bot reply time", desc: "faster than any human" },
      { value: 14, suffix: " days", label: "Brief to live", desc: "your website ready to sell" },
    ],
    origin: {
      eyebrow: "our story",
      title_q: "Why ",
      title_name: "Zenko",
      title_end: "?",
      char1_label: "Japanese · Korean",
      char1_jp: "Zen",
      char1_kr: "Seon",
      char1_meaning: "Kindness · Clarity · Doing good",
      char2_label: "Japanese",
      char2_jp: "Ko",
      char2_meaning: "Fox · Intelligent messenger",
      story_p1_a: "Zenko has roots in ",
      story_p1_b: "Japanese and Korean culture",
      story_p1_c: ". In Japanese, ",
      story_p1_d: " means ",
      story_p1_e: "“good fox”",
      story_p1_f: " — the intelligent messenger that, in Shinto mythology, works silently to bring prosperity to businesses. ",
      story_p1_g: "No deception, no friction",
      story_p1_h: " — acts with precision and loyalty so things happen.",
      story_p2_a: "In Korean, the character ",
      story_p2_b: " is read ",
      story_p2_c: "Seon",
      story_p2_d: " and means ",
      story_p2_e: "kindness and clarity",
      story_p2_f: " — doing things right, with no unnecessary noise.",
      story_right_a: "Together, both meanings define what we are: ",
      story_right_b: "an intelligent ally",
      story_right_c: " that works silently behind your business, with AI technology, so you see results without needing to understand how it works under the hood.",
      manifesto_eyebrow: "— the manifesto",
      manifesto_a: "Zenko ",
      manifesto_b: "is not the protagonist",
      manifesto_c: " — it makes ",
      manifesto_d: "you the one",
      manifesto_e: ".",
    },
    process: {
      eyebrow: "how we work",
      title_a: "From chaos to ",
      title_h: "autopilot",
      title_b: " in 14 days.",
      subtitle: "No endless meetings. No contracts you don't understand. Just 3 steps.",
      steps: [
        { n: "01", time: "Day 1", title: "Diagnosis", desc: "30-min call. We map which tasks drain your time and which customers slip away because you can't reply fast enough.", deliverable: "Custom plan · free" },
        { n: "02", time: "Day 2–10", title: "Design + AI", desc: "We design your site and train your chatbot with your menu, prices, FAQ and brand tone. You approve it.", deliverable: "Prototype + bot flows" },
        { n: "03", time: "Day 14", title: "Launch", desc: "We deploy to your domain, connect WhatsApp Business and train you and your team in 1 session.", deliverable: "Live · measuring sales" },
      ],
    },
    services: {
      eyebrow: "services",
      title_a: "Three solutions. One goal:",
      title_h: "you sell more",
      title_b: " with less effort.",
      subtitle: "Combine them or use them separately. You decide how to scale.",
      cta: "I want this",
      items: [
        { title: "AI Websites", tagline: "A site that sells while you sleep", bullets: ["Custom design (no generic templates)", "Optimized for Google · SEO included", "Loading speed < 1.5 sec"] },
        { title: "WhatsApp Chatbot", tagline: "Replies, books and sells without you", bullets: ["Connected to your WhatsApp Business", "Trained on your menu, prices and FAQ", "Books appointments and collects payments in chat", "Alerts you when something needs your attention"] },
        { title: "Smart eCommerce", tagline: "Online store with automated payments", bullets: ["Unlimited catalog · manage from your phone", "Payments: card, transfer, cash", "Auto reminders for abandoned carts", "WhatsApp integration for support"] },
      ],
      preview_real: "Real case · client",
      preview_live: "live",
      preview_see: "view live →",
    },
    demo: {
      eyebrow: "live demo",
      title_a: "Meet your future bot,",
      title_h: "at work.",
      subtitle: "This is what your customers receive on WhatsApp. Switch between scenarios and see how Zen handles each conversation without losing the human tone.",
      bullets: [
        { t: "Replies in < 2 seconds", d: "even at 3 AM" },
        { t: "Converts 3× more conversations", d: "than a tired human" },
        { t: "Learns your business", d: "and improves with every chat" },
      ],
      phone_name: "Zen · AI Assistant",
      phone_status: "online · replies instantly",
      phone_placeholder: "Type a message...",
      open_link: "Open link →",
      hint: "↑ Live demo · Switch scenarios",
      tabs: [
        { id: "reservas", label: "Bookings", emoji: "📅" },
        { id: "ventas", label: "Sales", emoji: "💰" },
        { id: "soporte", label: "Support", emoji: "🎧" },
      ],
    },
    comparison: {
      eyebrow: "before vs after",
      title_a: "The day you ",
      title_h: "stop losing customers",
      title_b: " for not replying.",
      subtitle: "These are the real changes our SMBs see in their first month with Zenko.",
      col_metric: "Metric",
      col_before: "Without Zenko",
      col_after: "With Zenko",
      rows: [
        { topic: "Response to new customers", before: "2–6 hours", after: "< 2 seconds" },
        { topic: "Weekend attention", before: "Nonexistent", after: "Continuous, 24/7" },
        { topic: "Lost carts / bookings", before: "~40%", after: "< 8%" },
        { topic: "Your time replying chats", before: "3 hrs / day", after: "20 min / day" },
        { topic: "Customers handled at once", before: "1 at a time", after: "Hundreds in parallel" },
      ],
    },
    case_study: {
      eyebrow: "case study",
      title_a: "MotoTuning C.A.,",
      title_h: "digital from zero",
      title_b: ".",
      subtitle: "How we built a Venezuelan motorcycle assembler their first professional digital presence in under 14 days.",
      label_brief: "The brief",
      brief: "Motorcycle assembler and distributor in Aragua, Venezuela. No site, no digital presence. They needed a professional site to showcase their 3 models, receive wholesale inquiries and position themselves as a serious brand against international competition.",
      label_solution: "What we delivered",
      solution: [
        "Institutional website designed and developed from scratch",
        "mototuningca.com domain configured",
        "Professional hosting included (1 year)",
        "Models section with detailed specs",
        "Wholesale contact form",
        "Full mobile optimization",
      ],
      label_outcome: "The outcome",
      outcome_a: "Real digital presence ",
      outcome_b: "for the business. A site ready to scale into eCommerce when they want.",
      label_time: "Total time",
      time: "10 days · brief to production",
      label_quote: "In the client's words",
      quote: "Zenko built us a professional website from scratch, with domain and hosting included. The process was fast, the result exceeded our expectations and we now have a real digital presence for our business. Totally recommended.",
      quote_attr: "MotoTuning C.A. · Aragua, Venezuela",
      visit: "View the live site",
      next_label: "Your case, next?",
      next_cta: "Tell us about your business",
    },
    powered_by: {
      eyebrow: "tech we use",
      title_a: "Built on the ",
      title_h: "best tools",
      title_b: " in the market.",
      subtitle: "We don't reinvent the wheel. We connect leading APIs so your business benefits from world-class technology.",
      items: [
        { name: "WhatsApp Business", desc: "Official verified messaging" },
        { name: "OpenAI · Claude", desc: "Conversational AI models" },
        { name: "Google Workspace", desc: "Calendar · Meet · Drive" },
        { name: "Stripe", desc: "Secure multi-currency payments" },
        { name: "Cal.com", desc: "Automated scheduling" },
        { name: "Vercel · AWS", desc: "High-speed hosting" },
      ],
    },
    pricing: {
      offer: "Launch offer · first 30 days",
      eyebrow: "transparent pricing",
      title_a: "Clear investment. ",
      title_h: "No surprises.",
      subtitle: "Your build + monthly maintenance so your site and bot keep running smoothly.",
      from: "from",
      one_time: "initial investment",
      maint: "+ monthly maintenance",
      iva_note: "* VAT not included. Applies to all three plans.",
      popular: "⭐ Most chosen",
      help_a: "Not sure which plan you need? ",
      help_b: "We'll help you decide →",
      plans: [
        { name: "Informative Site", price: "300", tag: "Ideal to start", featured: false, perks: ["1 page or landing", "Custom design", "Contact form", "Hosting + domain (1 year)", "Basic SEO optimization"] },
        { name: "Site + WA Chatbot", price: "700", tag: "Most popular · 70% pick this", featured: true, perks: ["Everything above +", "AI WhatsApp chatbot", "Custom training", "Auto scheduling", "Monthly reports"] },
        { name: "AI eCommerce", price: "1,500", tag: "To scale seriously", featured: false, perks: ["Complete online store", "Unlimited catalog", "Integrated payments", "Sales chatbot", "Cart recovery"] },
      ],
      start: "Start with",
    },
    testimonials: {
      eyebrow: "what our clients say",
      title_a: "Real stories,",
      title_h: "real results",
      title_b: ".",
      real_label: "real case",
      placeholder_title: "Your story, here.",
      placeholder_desc_a: "We're signing new cases every week.",
      placeholder_desc_b: "The next one could be yours.",
      cta_eyebrow: "Want to be next?",
      cta_title: "Book a call and tell us about your business.",
      cta_action: "Start now",
      visit_site: "View the site we built",
    },
    faq: {
      eyebrow: "frequently asked",
      title: "We answer what everyone asks.",
      items: [
        { q: "How long does it take to go live?", a: "Between 7 and 14 days from brief approval. Simple websites go faster; eCommerce with chatbot takes the full 14." },
        { q: "Do I need to know tech?", a: "Not at all. You tell us about your business on a call and we handle everything. We hand you a simple panel where you can edit text and prices if you want." },
        { q: "Does the chatbot sound robotic?", a: "No. We train it with your brand tone, local slang and replies you approve. Most customers don't even realize it's a bot." },
        { q: "What if I want to change something later?", a: "Minor changes (text, prices, photos) you do yourself from the panel. For big changes, you get direct WhatsApp support with me." },
        { q: "Do you charge monthly fees?", a: "Yes. The plan price covers the initial development. After that, a monthly maintenance fee applies, including hosting, domain, WhatsApp support, content updates and chatbot improvements. We'll detail the exact amount per plan on the call." },
        { q: "Which countries do you serve?", a: "We serve Spain, all of Latin America and the United States. You receive payments in your local currency and your chatbot supports multiple languages (ES/EN)." },
      ],
    },
    cta_section: {
      offer: "Limited slots · January 2026",
      title_a: "",
      title_h: "Shall we start today",
      title_b: "?",
      subtitle: "Pick the day and time that works best. 15-min call, free and no commitment.",
      hint: "↑ Click an available day (in mint) to see open slots",
      alt_label: "or if you prefer to message us directly",
      wa: "Direct WhatsApp",
      phone: "+34 697 718 231",
      checks: ["✓ Free call", "✓ No obligation", "✓ We reply in < 2 hours", "✓ Custom plan"],
    },
    floating: {
      text_a: "✦ Ready for your first automation?",
      cta: "Book a call",
      close: "Close",
    },
    footer: {
      tagline: "AI automation for SMBs that want to grow without complicating things.",
      values: [
        { jp: "誠", label: "Loyalty", desc: "we work for your success" },
        { jp: "静", label: "Silence", desc: "no unnecessary noise" },
        { jp: "智", label: "Intelligence", desc: "AI at the service of business" },
        { jp: "栄", label: "Prosperity", desc: "results that you feel" },
      ],
      cols: [
        { t: "Services", l: ["Websites", "WhatsApp Chatbot", "AI eCommerce", "Support"] },
        { t: "Company", l: ["About", "Case studies", "Blog", "Contact"] },
        { t: "Legal", l: ["Terms", "Privacy", "Cookies"] },
      ],
      copy: "© {year} Zenko · Built with AI and lots of care · Spain · LATAM · US",
      wa_hover: "Let's talk!",
      instagram: "Follow us on Instagram",
    },
    common: {
      lang_es: "ES",
      lang_en: "EN",
    },
  },
};
